import classNames from "classnames";
import { ReactComponent as Email } from "../../assets/email.svg";
import { ReactComponent as Github } from "../../assets/github.svg";
import { ReactComponent as Linkedin } from "../../assets/linkedin.svg";
import { useSelector } from "react-redux";

function SocialLinks() {
  const { showSocialLinksFullyLabelled } = useSelector((state) => state.app);
  return (
    <div
      style={{ top: "calc(97vh - 150px)" }}
      className="w-[200px] h-[150px] absolute right-0 z-30"
    >
      <div className="w-full h-full">
        <a
          href="https://www.linkedin.com/in/rohan-sharma-323593202/"
          target="_blank"
          rel="noreferrer"
          title="LinkedIn"
          className={classNames(
            "w-max h-max flex flex-row items-center hover:underline decoration-white social-link transition-right-bottom absolute",
            {
              "bottom-[0px] right-[109px]": !showSocialLinksFullyLabelled,
              "bottom-[79px] right-6": showSocialLinksFullyLabelled,
            }
          )}
        >
          {showSocialLinksFullyLabelled && (
            <div className="flex flex-col mr-2 overflow-hidden relative inherit-text-decoration">
              <span className="social-link-label invisible">LinkedIn</span>
              <span className="social-link-label social-link-label-animate absolute right-[-100%] inherit-text-decoration">
                LinkedIn
              </span>
            </div>
          )}
          <Linkedin />
        </a>
        <a
          href="https://github.com/rohan843"
          target="_blank"
          rel="noreferrer"
          title="GitHub"
          className={classNames(
            "w-max h-max flex flex-row items-center hover:underline decoration-white social-link transition-right-bottom absolute",
            {
              "bottom-[0px] right-[68px]": !showSocialLinksFullyLabelled,
              "bottom-[38px] right-6": showSocialLinksFullyLabelled,
            }
          )}
        >
          {showSocialLinksFullyLabelled && (
            <div className="flex flex-col mr-2 overflow-hidden relative inherit-text-decoration">
              <span className="social-link-label invisible">GitHub</span>
              <span className="social-link-label social-link-label-animate absolute right-[-100%] inherit-text-decoration">
                GitHub
              </span>
            </div>
          )}
          <Github />
        </a>
        <a
          href="mailto:rohan.sharma2934@gmail.com"
          title="Email"
          className={classNames(
            "w-max h-max flex flex-row items-center hover:underline decoration-white social-link absolute right-6 bottom-[0px]"
          )}
        >
          {showSocialLinksFullyLabelled && (
            <div className="flex flex-col mr-2 overflow-hidden relative inherit-text-decoration">
              <span className="social-link-label invisible">Email</span>
              <span className="social-link-label social-link-label-animate absolute right-[-100%] inherit-text-decoration">
                Email
              </span>
            </div>
          )}
          <Email />
        </a>
      </div>
    </div>
  );
}

export default SocialLinks;
